<template>
    <div>
        <kgr-loading v-if="loading" />
        <div v-else-if="members && members.length > 0">
            <kgr-members-table
                v-if="view === 'list'"
                :members="members"
            />
            <kgr-members-grid
                v-if="view === 'grid'"
                :members="members"
            />
            <div
                v-if="canLoadMore"
                class="kgr-row kgr-row--inverse kgr-text--centered"
            >
                <button
                    v-t="'Weitere Ergebnisse laden'"
                    class="kgr-button kgr-button--danger"
                    @click="$emit('loadMore')"
                ></button>
            </div>
        </div>
        <div
            v-else
            class="kgr-text--centered kgr-text--muted"
        >
            <p>{{ $t('Keine Suchergebnisse') }}</p>
        </div>
    </div>
</template>

<script>
import Loading from '../common/Loading.vue';
import MembersGrid from './MembersGrid.vue';
import MembersTable from './MembersTable.vue';

export default {
    components: {
        'kgr-members-grid': MembersGrid,
        'kgr-members-table': MembersTable,
        'kgr-loading': Loading,
    },
    props: {
        members: {
            type: Array,
            required: false,
        },
        view: {
            type: String,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
            default: false,
        },
        canLoadMore: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>
